import { render, staticRenderFns } from "./CreateCourseModal.vue?vue&type=template&id=43699347&"
import script from "./CreateCourseModal.vue?vue&type=script&setup=true&lang=ts&"
export * from "./CreateCourseModal.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports